// Matemática de color pura, sin React — compartida entre `fundamentalTintStyle` (pantalla, CSS) y
// `excelTintStyle` (export Excel, ARGB): la misma mezcla con blanco y el mismo umbral de luminancia
// para decidir texto blanco/oscuro, solo cambia el formato de salida de cada consumidor.

/** Componentes RGB de un color hexadecimal (`#RGB` o `#RRGGBB`). */
export function hexARgb(hex: string): [number, number, number] {
  const limpio = hex.replace('#', '');
  const completo = limpio.length === 3 ? limpio.split('').map((canal) => canal + canal).join('') : limpio;
  const entero = parseInt(completo, 16);
  return [(entero >> 16) & 255, (entero >> 8) & 255, entero & 255];
}

/** Luminancia perceptual 0-1, para decidir si el texto sobre un color debe ser claro u oscuro. */
export function luminancia([rojo, verde, azul]: readonly [number, number, number]): number {
  return (0.299 * rojo + 0.587 * verde + 0.114 * azul) / 255;
}

/** Mezcla `colorBase` con blanco según `intensidad` (0-1): 1 = color puro, 0 = blanco puro. */
export function mezclarConBlanco(colorBase: string, intensidad: number): [number, number, number] {
  const [rojo, verde, azul] = hexARgb(colorBase);
  const mezclar = (canal: number) => Math.round(canal * intensidad + 255 * (1 - intensidad));
  return [mezclar(rojo), mezclar(verde), mezclar(azul)];
}
